// extracted by mini-css-extract-plugin
export default {"button":"CommentToggle_button__fT+xl"};